<template>
  <div>
    <div v-if="canBeDownloaded">
      <b-container :style="backgroundImagePath">
        <b-row :align-h="showImgLeft ? 'between' : 'end'" class="pt-1 header">
          <b-col cols="4" v-if="showImgLeft">
            <b-img
              fluid
              :src="headerImgLeft"
              @error="handleImgErrorLeft"
              class="header-img-left"
              alt="header-img-left"
            />
          </b-col>

          <b-col cols="4" class="header-right" align-self="end">
            <b-img
              fluid
              :src="headerImgRight"
              class="header-img-right"
              alt="header-img-right"
            />
            <span class="header-img-right-caption">
              {{ headerCaption }}
            </span>
          </b-col>
        </b-row>

        <b-row class="pt-5 body">
          <b-col cols="12">
            <p>
              {{ destinationCityName }},
              {{ createdAt | moment("D [de] MMMM [del] YYYY") }}
            </p>
            <p class="pt-5">
              Señores
              <br />
              <em class="bold text-uppercase">{{ laborUnionName }}</em>
              <br />
              {{ capitalizeText(petitioner.name) }}
              <br />
              <span class="bold">
                {{ petitioner.role }}
              </span>
            </p>

            <p class="pt-5">
              Ref: Retractación del permiso Sindical número {{ licenseId }}
            </p>

            <p class="pt-5">Respetados señores:</p>

            <p class="pt-4">
              Por medio de la presente comunicación nos permitimos informarles
              que la Compañía no le resultó posible modificar la programación de
              turnos del personal, razón por la cual no es posible conceder el
              permiso sindical solicitado con las siguientes especificaciones:
            </p>

            <div class="pt-4">
              <table-collaborator :fields="fields" :items="items" />
            </div>

            <p class="pt-4">
              En las fechas solicitadas no es viable aprobar el permiso dado que
              se requiere el apoyo del trabajador para dar continuidad al
              proceso y no afectar la operación de la Compañía por la siguientes
              razones
              <span> {{ isEdit ? objectEdit.motive : getMotiveToString }}</span>
            </p>

            <p class="pt-4">
              En efecto, debe recordarse que la Corte Constitucional en
              repetidas ocasiones ha señalado que el derecho de obtener permisos
              sindicales no es absoluto, sino que debe cumplir con ciertos
              requisitos que son evaluados por el empleador al momento que
              decide otorgarlos o negarlos.
            </p>

            <p class="pt-4">
              Sobre el particular, en sentencia T-464 de 2010 la Alta Corte
              indicó que “el uso de los permisos sindicales debe estar apoyado
              en los principios de necesidad, proporcionalidad y razonabilidad,
              pues su abuso mengua la importancia de éstos y mina, en sí mismo,
              la eficacia y preponderancia de la acción sindical”.
            </p>

            <p class="pt-4">
              Por lo tanto, si bien los permisos sindicales constituyen una
              garantía para la efectividad del derecho de asociación sindical,
              no pueden ser vistos como una garantía ilimitada o absoluta, sino
              que están sujetos a los criterios de necesidad, proporcionalidad,
              razonabilidad y al cumplimiento de los términos en que debe
              realizarse la solicitud de los permisos, de conformidad con lo
              pactado por las partes. En este sentido y con fundamento en lo
              anteriormente expuesto, reiteramos que no es posible otorgar el
              permiso sindical por Usted solicitado, por lo tanto, la Compañía
              revoca el permiso sindical erróneamente reconocido.
            </p>

            <p class="pt-4">Cordialmente,</p>

            <div class="pb-2">
              <b-img
                fluid
                :src="businessPartner.signature"
                class="signature-business-partner"
                alt="signature-business-partner"
              />
            </div>

            <p class="pt-4">
              {{ capitalizeText(businessPartner.name) }}
              <br />
              {{ businessPartner.role }}
              <br />
              {{ businessPartner.society }}
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <b-alert show variant="danger">
        Aún no se han hecho retractaciones
      </b-alert>
    </div>
  </div>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />
